import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { RoomItem, SeatingChart, Wall } from '@td/shared';
import { get, post, put } from '../lib/api';

const KEY = ['seating'];

export function useSeatingChart() {
  return useQuery({ queryKey: KEY, queryFn: () => get<SeatingChart>('/seating') });
}

export interface SaveChartInput {
  name?: string;
  /** The room's measurements in feet; units are derived from these. */
  widthFt?: number;
  heightFt?: number;
  /** Pins the furniture; students stay movable. */
  locked?: boolean;
  wallLabels?: Record<Wall, string>;
  items: RoomItem[];
}

export function useSaveChart() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: SaveChartInput) => put<SeatingChart>('/seating', input),
    // The canvas is the source of truth mid-edit, so the response is written
    // straight into the cache instead of triggering a refetch that could
    // fight with a drag already in progress.
    onSuccess: (chart) => qc.setQueryData(KEY, chart),
  });
}

export function useResetChart() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => post<SeatingChart>('/seating/reset'),
    onSuccess: (chart) => qc.setQueryData(KEY, chart),
  });
}
